<template>
  <v-card
    class="mt-4"
    rounded="sm"
  >
    <div class="p-4 border-bottom">
      <h6 class="text-black mb-0 font-weight-bold">
        Calendário
      </h6>
    </div>
    <p class="mt-4 ml-6 mb-0 pb-0 text-black">
      Confira abaixo as principais datas do ciclo atual e as novidades da semana no evo | nitro
    </p>
    <events-calendar
      period="week"
    />
  </v-card>
</template>
<script>
import EventsCalendar from '@/student/components/calendar/EventsCalendar.vue';

export default {
  components: {
    EventsCalendar
  }
}
</script>
